import Image from './Image.vue';
import type { Meta, StoryObj } from '@storybook/vue3';
import type { ImageSrcsetItem } from './Image.vue';
const defaultSrcset: ImageSrcsetItem[] = [
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-7196514f.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-a83681a9.webp',
    breakpoint: 390,
    type: 'image/webp',
    width: 390,
    height: 390,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-7bc67de9.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-da1bf31b.jpg',
    breakpoint: 390,
    type: 'image/jpeg',
    width: 390,
    height: 390,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-a706d850.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-b5387fad.webp',
    breakpoint: 575,
    type: 'image/webp',
    width: 575,
    height: 575,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-41b1583b.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-28f12a35.jpg',
    breakpoint: 575,
    type: 'image/jpeg',
    width: 575,
    height: 575,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-ac172197.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-f2653798.webp',
    breakpoint: 768,
    type: 'image/webp',
    width: 768,
    height: 415,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-908fcf8a.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-628820d2.jpg',
    breakpoint: 768,
    type: 'image/jpeg',
    width: 768,
    height: 415,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-7df20b97.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-f2653798.webp',
    breakpoint: 992,
    type: 'image/webp',
    width: 992,
    height: 518,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-a7d9cb1d.jpg',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-ed325d1a.jpg',
    breakpoint: 992,
    type: 'image/jpeg',
    width: 992,
    height: 518,
  },
  {
    imagePath1x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-4a8f7414.webp',
    imagePath2x:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-2cda2a28.webp',
    breakpoint: null, // Default size
    type: 'image/webp',
    width: 1200,
    height: 530,
  },
];

const meta: Meta<typeof Image> = {
  title: 'Atoms/Media/Image',
  tags: ['atoms', 'autodocs'],
  component: Image,
  argTypes: {
    imageCaption: {
      control: 'text',
      description: 'Caption for the image',
    },
    imageCaptionPosition: {
      control: 'select',
      description: 'Caption position',
      options: ['left', 'center', 'right'],
    },
    imageRoundedCorners: {
      control: 'boolean',
      description: 'Round corners for image',
    },
    imageForceAspectRatio: {
      control: 'select',
      description: 'Force aspect ratio on image (cropping will occur)',
      options: ['4_3', '16_9', '1_1', '3_4'],
    },
    imageForceAspectRatioMobile: {
      control: 'select',
      description:
        'Force aspect ratio on image for mobile (cropping will occur)',
      options: ['4_3', '16_9', '1_1', '3_4'],
    },
    imageHorizontalFocus: {
      control: 'select',
      description: 'Image horizontal focus',
      options: ['left', 'center', 'right'],
      if: { arg: 'imageForceAspectRatio', truthy: true },
    },
    imageVerticalFocus: {
      control: 'select',
      description: 'Image vertical focus',
      options: ['top', 'center', 'bottom'],
      if: { arg: 'imageForceAspectRatio', truthy: true },
    },
    defaultSrc: {
      control: 'text',
      description: 'Default source image',
    },
    altTag: {
      control: 'text',
      description: 'Alternative text for the image',
    },
    defaultWidth: {
      control: 'number',
      description: 'Default image width',
    },
    defaultHeight: {
      control: 'number',
      description: 'Default image height',
    },
  },
  args: {
    imageCaption: 'Lorem ipsum copyrights.',
    imageCaptionPosition: 'left',
    imageRoundedCorners: true,
    imageForceAspectRatio: '',
    imageForceAspectRatioMobile: '',
    imageHorizontalFocus: '',
    imageVerticalFocus: '',
    defaultSrc:
      '/layout/storybook/sb-assets/Frau_mit_Handy_und_Kopfhoerern-c4804f5b.jpg',
    altTag:
      'Frau steht im pinken Licht mit Kopfhörern auf und schaut auf ihr Handy',
    imageSrcset: defaultSrcset,
    defaultWidth: '1200',
    defaultHeight: '530',
  },
} satisfies Meta<typeof Image>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    ...meta.args,
  },
};
